import { render, staticRenderFns } from "./DialogCreateEmployee.vue?vue&type=template&id=36cb3ef8&scoped=true"
import script from "./DialogCreateEmployee.vue?vue&type=script&lang=js"
export * from "./DialogCreateEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cb3ef8",
  null
  
)

export default component.exports